import React from 'react';
import { ScrollReveal } from '../components/ScrollReveal';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-cosmic-black relative z-10 py-12 px-6 border-y border-gold/10" data-id="element-95">
      <ScrollReveal className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-96">
        <div className="w-20 h-20 bg-cosmic-card rounded-full border-2 border-gold flex items-center justify-center mb-8 shadow-[0_0_30px_rgba(201,168,76,0.2)]" data-id="element-97">
          <Shield className="w-10 h-10 text-gold" data-id="element-98" />
        </div>

        <h2 className="font-playfair text-lunar-white text-4xl md:text-5xl font-bold leading-tight mb-8" data-id="element-99">
          Try It For 7 Nights.
          <br data-id="element-100" />
          If You Don't Feel a Shift —<br data-id="element-101" />
          <span className="text-gold" data-id="element-102">You Pay Nothing.</span>
        </h2>

        <div className="text-lunar-lavender text-lg leading-relaxed font-lato space-y-6 max-w-2xl" data-id="element-103">
          <p data-id="element-104">
            I am so confident that The Midnight Magnet will change something
            real in your life, I'm offering a full 7-day no-questions-asked
            guarantee.
          </p>
          <p data-id="element-105">
            If you read the scripts for 7 nights and feel zero shift in your
            energy, your mindset, or your love life — email us and we'll refund
            every cent.
          </p>
          <p data-id="element-106">No hoops. No forms. No judgment.</p>
          <p className="text-lunar-white font-semibold" data-id="element-107">
            Because this works. And I want you to experience that with zero
            risk.
          </p>
        </div>
      </ScrollReveal>
    </section>;
}